import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CreditCard, CreditCardValidators } from 'angular-cc-library';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService, UtilityService } from 'src/app/services';

@Component({
  selector: 'app-debit-card',
  templateUrl: './debit-card.component.html',
  styleUrls: ['./debit-card.component.scss']
})
export class DebitCardComponent implements OnInit {
  DEBITCARD!: FormGroup
  @Input() item: any;
  type$!: Observable<string>;
  debit_card_type = new FormControl ('');
  month = this.data.getMonth;
  expYears: number[] = this.util.getNextNyears(new Date(), 20);
  constructor(private fb: FormBuilder, private data: DataService, private util: UtilityService) { }

  ngOnInit(): void {
    // console.log('Initial item debit-card:', this.item);
    this.DEBITCARD = this.fb.group({
      debit_card_number: new FormControl('', [Validators.required, CreditCardValidators.validateCCNumber]),
      debit_card_type: this.debit_card_type,
      debit_card_exp_month: new FormControl('', Validators.required),
      debit_card_exp_year: new FormControl('', Validators.required),
      debit_card_cvv: new FormControl('', Validators.required),
      debit_card_holder_name: new FormControl('', Validators.required),
    });

    this.type$ = this.debit_card_number.valueChanges.pipe(
      map((num: string) => CreditCard.cardType(num))
    );
  }
  
  get debit_card_number(): FormControl {
    return this.DEBITCARD.get('debit_card_number') as FormControl;
  }

  getDEBITCARDFormValue(): any {
    if (this.DEBITCARD.invalid) {
      this.DEBITCARD.markAllAsTouched();
      return null;
    }
    return this.DEBITCARD.value;
  }
}
